import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./banners.css";

// MUI Link
import Link from "@mui/material/Link";

// Banners images
import banner1 from "../../assets/images/Banners/slider-1.jpg";
import banner2 from "../../assets/images/Banners/slider-2.jpg";
import banner3 from "../../assets/images/Banners/slider-3.jpg";

// Install modules for Swiper v8
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function TopLogoBar() {
  const banners = [
    { id: 1, img: banner1, alt: "Banner 1" },
    { id: 2, img: banner2, alt: "Banner 2" },
    { id: 3, img: banner3, alt: "Banner 3" },
  ];

  return (
    <div className="banners-section">
      <div className="container-fluid">
        <div className="row">
          {/* Banner Slider */}
          <div className="col-lg-8 col-md-12 col-sm-12">
            <Swiper
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop={true}
              spaceBetween={0}
              slidesPerView={1}
            >
              {banners.map((banner) => (
                <SwiperSlide key={banner.id}>
                  <img
                    src={banner.img}
                    alt={banner.alt}
                    className="img-fluid"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Notifications */}
          <div className="col-lg-4 col-md-12 col-sm-12">
            <section className="notifications-section">
              <div className="bannerNoticeBoard">
                <h2>📢 Latest Notifications</h2>
              </div>

              <div className="notification-card">
                <span className="date">29/07/2025</span> |{" "}
                <span className="category">Information</span> |{" "}
                <Link href="#">
                  OPENING AND CLOSING RANKS OF THE ADMITTED CANDIDATES UNDER
                  CATEGORY - B (ACADEMIC YEAR 2024-2025) FOR REFERENCE PURPOSE.
                </Link>
              </div>

              <div className="notification-card">
                <span className="date">01-Jul-2025</span> |{" "}
                <span className="category">Hall ticket Download</span> |{" "}
                <Link href="#">
                  HALL TICKET DOWNLOAD FOR BE - I SEMESTER SUPPLEMENTARY
                  EXAMINATIONS : JUL-25
                </Link>
              </div>

              <div className="notification-card">
                <span className="date">30-Jun-2025</span> |{" "}
                <span className="category">Photo Copy and Revaluation</span> |{" "}
                <Link href="#">
                  ONLINE REGISTRATION FORM FOR REVALUATION AND PHOTOCOPY OF THE
                  ANSWER SCRIPTS : BE IV SEMESTER MAIN&BACKLOG EXAMINATIONS HELD
                  IN MAY/JUN-2025
                </Link>
              </div>

              <div className="notification-card">
                <span className="date">30-Jun-2025</span> |{" "}
                <span className="category">Photo Copy and Revaluation</span> |{" "}
                <Link href="#">
                  ONLINE REGISTRATION FORM FOR REVALUATION AND PHOTOCOPY OF THE
                  ANSWER SCRIPTS : BE IV SEMESTER MAIN&BACKLOG EXAMINATIONS HELD
                  IN MAY/JUN-2025
                </Link>
              </div>

              <div className="notification-card">
                <span className="date">30-Jun-2025</span> |{" "}
                <span className="category">Photo Copy and Revaluation</span> |{" "}
                <Link href="#">
                  ONLINE REGISTRATION FORM FOR REVALUATION AND PHOTOCOPY OF THE
                  ANSWER SCRIPTS : BE IV SEMESTER MAIN&BACKLOG EXAMINATIONS HELD
                  IN MAY/JUN-2025
                </Link>
              </div>

              <div className="notification-card">
                <span className="date">30-Jun-2025</span> |{" "}
                <span className="category">Photo Copy and Revaluation</span> |{" "}
                <Link href="#">
                  ONLINE REGISTRATION FORM FOR REVALUATION AND PHOTOCOPY OF THE
                  ANSWER SCRIPTS : BE IV SEMESTER MAIN&BACKLOG EXAMINATIONS HELD
                  IN MAY/JUN-2025
                </Link>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
